import React from 'react';
import {
  Ticket,
  User,
  SignOut,
  ShoppingBag,
  UserCircle,
  Calendar,
  Bank,
  ChatsTeardrop,
  Notepad,
} from '@phosphor-icons/react';

export const userOptions = {
  buyer: [
    { id: 'events', label: 'Manage events', icon: <Calendar size='24'
      color='#101010'
    /> },
    { id: 'my-listing', label: 'My Listings', 
      icon: <Ticket
        size='24'
        color='#101010'
      /> },
      { id: 'bookings', label: 'My Bookings',  icon: <ShoppingBag size='24'
        color='#101010'
      /> },
    { id: 'support', label: 'Support', icon: <ChatsTeardrop size='24'
      color='#101010'
    /> },
    { id: 'user-profile', label: 'Profile', icon: <UserCircle size='24'
      color='#101010'
    /> },
    { id: 'logout', label: 'Log out', icon: <SignOut size='24'
      color='#101010'
    /> },
  ],
  organizer: [
    { id: 'manageEvents', label: 'Manage events', icon: <Calendar size='24'
      color='#101010'
    /> },
    { id: 'payout', label: 'Payout', icon: <Bank  size='24'
      color='#101010'
    /> },
    { id: 'support', label: 'Support', icon: <ChatsTeardrop size='24'
      color='#101010'
    /> },
    { id: 'myListings', label: 'My Listings',  icon: <Ticket size='24'
      color='#101010'
    /> },
    { id: 'myBookings', label: 'My Bookings',  icon: <ShoppingBag size='24'
      color='#101010'
    /> },
    { id: 'profile', label: 'Profile', icon: <User  size='24'
      color='#101010'
    /> },
    { id: 'logout', label: 'Log out', icon: <SignOut  size='24'
      color='#101010'
    /> },
  ],
};

export const adminPanelOption = [{
  id: 'admin/primary',
  label: 'Primary Admin Panel',
  icon: <Notepad size='24' color='#101010' />,
},
{
  id: 'admin/events',
  label: 'Secondary Admin Panel',
  icon: <Notepad size='24' color='#101010' />,
}];
